/**
 * @author：
 * @update：
 * @description：
 **/
import {logout, userInfo} from '../../config/config'
export default {
    data() {
        return {};
    },
    // 自定义方法
    methods: {
        //查询用户信息
        userInfo(){
            this.$ajax.get(userInfo).then((res)=>{
                console.log(res);
                let num = res.data.accesses.length;
                if(num==0){
                    sessionStorage.clear();
                    sessionStorage.setItem('out','true');
                    this.$store.commit('setHomePageIsHidden',false);
                    alert('您暂无当前系统的菜单权限，请联系管理员开通');
                    setTimeout(function(){
                        window.location.href = logout
                    },150)
                }
                let bol = false;
                for(let i = 0; i < res.data.accesses.length; i++){
                    if(res.data.accesses[i].indexOf('mall.')!=-1){
                        bol = true
                    }
                    if(num==i+1){
                        if(bol){
                            this.$store.commit('setHomePageIsHidden',false);
                            this.$store.commit("updateUserInfo", res.data);
                            sessionStorage.setItem('userId',res.data.userId);
                            //查询用户是否认证
                            // if(res.data.certification!=undefined){
                            //     this.isName = res.data.certification.state=='CERTIFIED'?true:false;
                            // }
                            if(sessionStorage.getItem('jumpRouter')!=null){
                                this.$router.push({path:sessionStorage.getItem('jumpRouter')})
                            }else{
                                this.$router.push({path:'/'})
                            }
                        }else{
                            sessionStorage.clear();
                            sessionStorage.setItem('out','true');
                            this.$store.commit('setHomePageIsHidden',false);
                            alert('您暂无当前系统的菜单权限，请联系管理员开通')
                            setTimeout(function(){
                                window.location.href = logout
                            },150)
                        }
                    }
                }
            },(err)=>{
                console.log(err);
                this.$message({
                    showClose: true,
                    message: err.data,
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            })
        },
    },
    // 数据观察监听
    watch: {

    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.userInfo()
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
